import { SDrawerOrModal, SGeneralForms } from "shj-components";
import React, { useEffect, useState } from "react";
import { Form, message } from "antd";
import { httpOrgList } from "@/services/homeService.ts";
import { getProductCommonPage, getProductList, warningRulesAdd, warningRulesUpdate } from "@/services/product.ts";
import DebounceSelect from "@/pages/baseProduct/components/DebounceSearchSelect";
import { isEmpty } from "lodash-es";

const AddOrEditModal = (props) => {
  const {open, record, onClose, onReload} = props;
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [productId, setProductId] = useState('')
  const minValue = Form.useWatch('minValue', form)
  const maxValue = Form.useWatch('maxValue', form)

  useEffect(() => {
    if(open){
      if(!isEmpty(record)){
        form.setFieldsValue(record);
        setProductId(record.productId)
      } else {
        form.setFieldsValue({productIds: ['0'], shopIds: ['0']});
      }

    }
    return () => {
      form.resetFields()
    }
  }, [open]);

  const getOptions = () => {
    setLoading(true)
    return Promise.all([
      httpOrgList({status: undefined}),
    ]).then(res => {
    return {companyList: [{name: '通用', id: '0'}, ...res[0]]}
    }).finally(() => {
      setLoading(false)
    })
  }

  const onSelectProduct = ({ value }) => {
    console.log(value, record)
    if(!record.id) {
      const productIds = form.getFieldValue('productIds')
      if(value === '0'){
        form.setFieldsValue({productIds: ['0']})
      } else {
        form.setFieldsValue({productIds: productIds.filter(productId => productId !== '0')})
      }
    } else {
      setProductId(value)
      form.setFieldValue('productId', value)
    }
  }

  const onSubmit = () => {
    form.validateFields().then(values => {
      setLoading(true)
      const apiUrl = record?.id ? warningRulesUpdate : warningRulesAdd
      apiUrl({ ...values, ruleType: 'STANDARD_CONFIG' }).then(res => {
        message.success(res.message || '操作成功')
        onClose?.()
        onReload?.()
      }).finally(() => setLoading(false))
    })
  }

  return <SDrawerOrModal
    width={600}
    mode={'modal'}
    title={record?.id ? '编辑配置' : '新增配置'}
    open={open}
    okText={'确定'}
    onCancel={onClose}
    onOk={onSubmit}
    loading={loading}
  >
    <SGeneralForms
      layout={'vertical'}
      formConfig={{form}}
      httpOptionsFn={getOptions}
      configs={[{
        formItem: [
          {name: 'id', hidden: true},
          {
            spanCol: 24,
            label: '适用产品',
            name: record.id ? 'productId' : 'productIds',
            required: true,
            rules: [{required: true, message: '适用产品不能为空'}],
            children: <DebounceSelect
              allowClear
              label={'产品'}
              isCommon={true}
              mode={record.id ? undefined : 'multiple'}
              fixedParams={{ prodTypes: ['PRODUCT_PACKAGE'] }}
              fetchOptions={getProductCommonPage}
              fieldNames={{ label: 'prodName', value: 'id' }}
              onSelect={onSelectProduct}
              onChange={(v) => {
                setProductId(v)
              }}
              query={(record.id && productId) ? {id: productId} : {}}
            />
          },
          {
            spanCol: 24,
            label: '适用门店',
            name: record.id ? 'shopId' : 'shopIds',
            required: true,
            rules: [{required: true, message: '适用门店不能为空'}],
            type: 'select',
            data: 'companyList',
            comConfig: {
              mode: record.id ? undefined : 'multiple',
              fieldNames: {label: 'name', value: 'id'},
              [!record.id ? 'onSelect' : '']: (v) => {
                const shops = form.getFieldValue('shopIds')
                if(v === '0'){
                  form.setFieldsValue({shopIds: ['0']})
                } else {
                  form.setFieldsValue({shopIds: shops.filter(shop => shop !== '0')})
                }
              }
            }
          },
          {
            spanCol: 12,
            label: '成本差比率最低',
            name: 'minValue',
            type: 'inputNumber',
            rules: [{required: !minValue && !maxValue, message: '成本差比率最低最高至少有一项必填'}],
            comConfig:{
              addonAfter: '%',
              min: -999999.99,
              max: 999999.99,
              precision: 2,
              onChange: ()=> {
                form.validateFields(['maxValue'])
              }}
          },
          {
            spanCol: 12,
            label: '成本差比率最高',
            name: 'maxValue',
            type: 'inputNumber',
            rules: [{validator: () =>{
                if((minValue && maxValue) && minValue >= maxValue){
                  return Promise.reject('成本差比率最高需大于成本差比率最低')
                }
                return Promise.resolve()
              }}],
            comConfig:{
              addonAfter: '%',
              min: 0.01,
              max: 999999.99,
              precision: 2
            }
          }
        ]
      }]}/>
  </SDrawerOrModal>
}

export { AddOrEditModal }